import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const PrintQRCode = ({ url, label }) => {
  if (!url) return null;
  return (
    <div
      className="qr-print-only"
      style={{ textAlign: "center", marginTop: "5px" }}
    >
      <QRCodeCanvas value={url} size={60} marginSize={1} />
      <div style={{ fontSize: "9px", color: "#333", marginTop: "2px" }}>
        {label}
      </div>
    </div>
  );
};

export default PrintQRCode;
